import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

const useRolesApi = () => {
  const getInternalRoles = useCallback(async () => {
    const response = await axiosInstance.get('/api/roles/by-type/internal');
    return response.data;
  }, []);

  const getExternalRoles = useCallback(async () => {
    const response = await axiosInstance.get('/api/roles/by-type/external');
    return response.data;
  }, []);

  const getRolePrivileges = useCallback(async (roleId) => {
    const response = await axiosInstance.get(`/api/roles-privileges/${roleId}`);
    return response.data;
  }, []);

  const getUsersWithCustomPrivilegesForRole = useCallback(async (roleId) => {
    const response = await axiosInstance.get(
      `/api/roles-privileges/${roleId}/custom-users`
    );
    return response.data;
  }, []);

  return {
    getInternalRoles,
    getExternalRoles,
    getRolePrivileges,
    getUsersWithCustomPrivilegesForRole,
  };
};

export default useRolesApi;
